<div class="card">
    <div class="card-body">
      <div class="d-flex mb-3">
        <h4 class="card-title">Users</h4>
        <button type="button" class="btn btn-primary ms-auto" (click)="addNewModal()">
          Add New
        </button>
      </div>
      <!-- <p class="card-description">
        Basic form layout
      </p> -->
      <ng-template #basicActions let-data="adtData" let-emitter="captureEvents">
        <app-user-actions [data]="data" (emitter)="emitter($event)"></app-user-actions>
      </ng-template>
      
      <app-admin-edit-user [modalid]="modalid" [user]="editUser" (newItemEvent)="changeData($event)"></app-admin-edit-user>
      <app-admin-add-user [modalid]="modalid2" [user]="editUser" (newItemEvent)="changeData($event)"></app-admin-add-user>
      <app-admin-common-delete [modalid]="modalid1" table="users" [id]="deleteid" (newItemEvent)="changeData($event)"></app-admin-common-delete>
      <!-- <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover"></table> -->
      <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table"></table>
    </div>
</div>